export default () => {
  if (
    document.querySelector(".page-banner") ||
    document.querySelector(".hero-slider") ||
    document.querySelector(".hero-video")
  ) {
    document.querySelectorAll(".js-site-header").forEach((el) => {
      el.classList.add("site-header--has-page-banner");
    });
  }
};
